var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9115 6.6665V17.4998C16.9115 17.9601 16.5384 18.3332 16.0781 18.3332H4.41146C3.95122 18.3332 3.57812 17.9601 3.57812 17.4998V2.49984C3.57812 2.0396 3.95122 1.6665 4.41146 1.6665H11.9115C12.1325 1.6665 12.3444 1.7543 12.5007 1.91058L16.6674 6.07725C16.8237 6.23353 16.9115 6.44549 16.9115 6.6665ZM10.2448 3.33317H5.24479V16.6665H15.2448V8.33317H11.0781C10.6179 8.33317 10.2448 7.96007 10.2448 7.49984V3.33317ZM11.9115 3.67835V6.6665H14.8996L11.9115 3.67835Z",
    fill: "white"
  }))));
};
export { SvgFile as ReactComponent };
export default __webpack_public_path__ + "assets/fbee9d22.svg";